<template>
  <v-card class="elevation-2">
    <v-toolbar dense>
      <v-toolbar-title class="subtitle-1">{{title}} Comments</v-toolbar-title>
      <!-- <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn icon @click="reloadMessage()">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-toolbar-items> -->
    </v-toolbar>
    <div class="container" style="background-color:#fff">
      <v-card flat max-height="300px" class="overflow-hidden overflow-y-auto">
        <v-card-text style="padding:0" v-if="messages.length > 0">
          <element v-for="(msg, index) in messages" :key="index">
            <p class="body-2 mb-1 font-weight-bold">{{msg.author}}</p>
            <p class="body-1 mb-1 font-weight-medium" v-html="renderHTML(msg.text)"></p>
            <p class="caption text-xs-right font-italic">{{getRelativeTime(msg.createdAt)}}</p>
            <v-divider></v-divider>
          </element>
        </v-card-text>
        <v-card-text v-else>
          <p class="body-1 mb-0 fong-weight-bold">
            No Comments
          </p>
        </v-card-text>
      </v-card>
      <v-card-actions v-if="!readOnly">
        <v-textarea
          outlined
          rows="3"
          auto-grow
          v-model="messageText"
          placeholder="Write your comments here..."
          style="max-height: 200px;overflow-y: auto;"
        ></v-textarea>
      </v-card-actions>
    </div>
    <v-btn v-if="!readOnly" block dark @click="sendMessage()">Add Comment</v-btn>
  </v-card>
</template>

<script>
import store from '@/store';
import moment from 'moment';
export default {
  name: 'chatBox',
  props: {
    messages: Array,
    title: String,
    readOnly: Boolean
  },
  data() {
    return {
      messageText: ''
    };
  },
  methods: {
    sendMessage: function() {
      var message = {
        text: this.messageText,
        createdAt: new Date(),
        author: store.state.user.firstName,
        self: true
      };
      if (this.messageText === '') {
        this.$swal.fire("Message can't be empty", '', 'error');
      } else {
        this.messages.push(message);
        this.$emit('sendMessage', this.messageText);
        this.messageText = '';
      }
    },
    reloadMessage: function() {
      this.$emit('reloadMessage');
    },
    getRelativeTime: function(date) {
      return moment(date).fromNow();
    },
    renderHTML(text) {
      if (text !== undefined && text !== null) {
        return text.replace(/\n/g, `<p><p>`);
      }
      return ''
    }
  }
};
</script>



// WEBPACK FOOTER //
// chatbox.vue?55f8ce76